// import { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { PrimeReactProvider } from 'primereact/api';

import Purchase from "./pages/purchase/Purchase";
import Team from "./pages/team/Team";
import Dasboard from "./pages/dashboard/Dashboard";
import LanguagePage from "./pages/language/LanguagePage";
import Settings from "./pages/settings/Settings";
import Login from "./pages/login/Login";
import Campaign from "./pages/campaign/Campaign";
import Participant from "./pages/participant/Participant"
import TeamLeader from "./pages/teamLeaders/TeamLeaders"
import UserTeams from "./pages/userTeams/UserTeams"
import Users from "./pages/users/Users"
import AppLeads from "./pages/app/AppLeads";
import AppKanban from "./pages/app/AppKanban";
import { BubblyContainer } from "./library/src";
import ProfileView from "./pages/profileView/ProfileView";
import Form from "./pages/form/Form";
import NewBuyerAppForm from "./pages/form/NewBuyerAppForm";
import NewLoanSetUpForm from "./pages/form/NewLoanSetUpForm";
import LeaderBoard from "./pages/app/LeaderBoard";
import ShoppersLeaderBoard from "./pages/app/ShoppersLeaderBoard";
import UserAvailability from "./pages/availability/UserAvailability";
import UserAvailabilities from "./components/mainSettings/UserAvailabilities";
import AppointmentAvailability from "./pages/availability/AppointmentAvailability";
import ShortForm from "./pages/form/ShortForm";
import OnboardedUsers from "./pages/users/OnboardedUsers";
import NewDesignedForm from "./pages/form/NewDesignedForm";
import BarChartSample from "./components/Chart/BarChartSample";
import Layout from "./shared/Layout";
import DashboardPage from "./pages/dashboard/DashboardPage";
import FlyerPage from "./pages/app/FlyerPage";
import FlyerLibrary from "./pages/app/FlyerLibrary";
import TrainingLibrary from "./pages/app/TrainingLibrary";
import NewDesignedBuyerAppForm from "./pages/form/NewDesignedBuyerAppForm";
import RealTimeAppsKanban from "./pages/app/RealTimeAppsKanban";
import NewHomeOwnerAppForm from "./pages/form/NewHomeOwnerAppForm";
import QueuePage from "./pages/app/QueuePage";
import UserActivityLogs from "./pages/app/UserActivityLogs";
import { refreshCloudfrontCookies } from "./utils/axios";
// import Language from "./components/languages/Language";
import PendingClosingQueue from "./pages/pendingClosingQueue/PendingClosingQueue";
import NewLeaderBoard from "./components/leaderBoard/NewLeaderBoard";
import Onboarding from "./pages/onboarding/Onboarding";
import OnboardingAdmin from "./pages/onboarding/OnboardingAdmin";
import HelpDesk from "./pages/helpDesk/HelpDesk";
import RepeatLeads from "./pages/repeatLeads/RepeatLeads";

function App() {

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     refreshCloudfrontCookies();
  //   }, 30000);
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <PrimeReactProvider value={{ zIndex: { modal: 1100, overlay: 9000, menu: 9000, tooltip: 9000 } }}>
    <BrowserRouter>
      <BubblyContainer />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/onboarding/:token" element={<Onboarding />} />
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Dasboard />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/team" element={<Team />} />
          <Route path="/participant" element={<Participant />} />
          <Route path="/users/:locationId" element={<Team />} />
          <Route path="/campaign" element={<Campaign />} />
          <Route path="/campaign_users/:campaignId" element={<Campaign />} />
          <Route path="/campaign_fallback_users/:campaignId" element={<Campaign />} />
          <Route path="/purchase" element={<Purchase />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/language" element={<LanguagePage />} />
          <Route path="/teams" element={<UserTeams />} />
          <Route path="/leader" element={<TeamLeader />} />
          <Route path="/users" element={<Users />} />
          <Route path="/onboarded-users" element={<OnboardedUsers />} />
          <Route path="/app" element={<AppLeads />} />
          <Route path="/app-kanban" element={<AppKanban />} />
          {/* <Route path="/users-kanban" element={<UsersKanban/>} /> */}
          <Route path="/app-table/:table" element={<AppKanban />} />
          <Route path="/app-kanban/:pipelineId" element={<AppKanban />} />
          <Route path="/real-time-apps/:pipelineId" element={<RealTimeAppsKanban />} />
          <Route path="/app/:contactId/:formId" element={<ProfileView />} />
          <Route path="/new-app-short" element={<ShortForm />} />
          <Route path="/new-homeowner-app" element={<NewHomeOwnerAppForm />} />
          <Route path="/new-app-form" element={<NewDesignedForm />} />
          <Route path="/new-app" element={<Form />} />
          <Route path="/new-buyer-app" element={<NewDesignedBuyerAppForm />} />
          <Route path="/new-buyer-app-form" element={<NewBuyerAppForm />} />
          <Route path="/new-loan-set-up-form" element={<NewLoanSetUpForm />} />
          <Route path="/leaderboard" element={<NewLeaderBoard />} />
          <Route path="/callers-leaderboard" element={<LeaderBoard />} />
          <Route path="/shoppers-leaderboard" element={<ShoppersLeaderBoard />} />
          <Route path="/user-availability/:userId" element={<UserAvailability />} />
          <Route path="/user-availability-appointment/:userId" element={<AppointmentAvailability />} />
          {/* <Route path="/user-availabilties" element={<UserAvailabilities />} /> */}
          <Route path="/user-availabilties" element={<UserAvailabilities />} />
          <Route path="/bar-chart" element={<BarChartSample />} />
          {/* <Route path="/flyer" element={<FlyerPage />} /> */}
          <Route path="/library" element={<FlyerLibrary />} />
          <Route path="/training-library" element={<TrainingLibrary />} />
          {/* <Route path="/queue" element={<QueuePage />} /> */}
          <Route path="/activity-logs" element={<UserActivityLogs />} />
          <Route path="/queue" element={<PendingClosingQueue />} />
          <Route path="/help-desk" element={<HelpDesk />} />
          <Route path="/onboarding-admin" element={<OnboardingAdmin />} />
          <Route path="/repeat-leads" element={<RepeatLeads />} />
          <Route path="*" element={<>No Match</>} />
        </Route>
      </Routes>
    </BrowserRouter>
    </PrimeReactProvider>
  );
}

export default App;
